import { lazy, Suspense } from "react";
import { useIdleTimer } from 'react-idle-timer'
import environment from 'environment';

import { Route, Switch } from "react-router-dom";
import "./App.scss";
import ThemeConfig from "./base/Theme";
import { preferenceService } from "./service/common/preference-service";
const Login = lazy(() => import("./auth/login/Login"));
const Main = lazy(() => import("./module/Main"));

function App() {
  let timer;

  const onIdle = () => {
    timer = setTimeout(() => {

      preferenceService.clearLocal();
      window.location.href = '/login';
    }, 1000 * 60 * environment.extendLogout)
  }

  const onActive = (event) => {
    clearTimeout(timer);
  }

  const idleTimer = useIdleTimer({
    timeout: 1000 * 60 * environment.idleTimeout,
    onIdle,
    onActive
  });

  return (
    <div className="App">
      <div id="glLoading" className="loading-container" hidden={true}>
        <div class="sk-cube-grid">
          <img src="/img/logo/logo.png" width={'100%'} alt="logo" />

        </div>
      </div>
      <ThemeConfig />
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route path="/" component={Login} exact={true} />
          <Route path="/login" component={Login} exact={true} />
          <Route component={Main} exact={true} />
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
